import { render } from "./IconBrakeDisk.vue?vue&type=template&id=29b36ea2&lang=pug&bindings={\"id\":\"props\"}"
import script from "./IconBrakeDisk.vue?vue&type=script&lang=js"
export * from "./IconBrakeDisk.vue?vue&type=script&lang=js"
script.render = render

export default script